"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.websocket = exports.webRTC = exports.voiceMails = exports.users = exports.sip = exports.session = exports.rooms = exports.notifications = exports.notification = exports.network = exports.members = exports.feeds = exports.feedItems = exports.entities = exports.default = exports.contacts = exports.app = exports.activities = void 0;
var activitiesImport = require("../resources/activities/types.js");
var activities = exports.activities = activitiesImport;
var appImport = require("../resources/app/types.js");
var app = exports.app = appImport;
var contactsImport = require("../resources/contacts/types.js");
var contacts = exports.contacts = contactsImport;
var entitiesImport = require("../resources/entities/types.js");
var entities = exports.entities = entitiesImport;
var feedItemsImport = require("../resources/feedItems/types.js");
var feedItems = exports.feedItems = feedItemsImport;
var feedsImport = require("../resources/feeds/types.js");
var feeds = exports.feeds = feedsImport;
var membersImport = require("../resources/members/types.js");
var members = exports.members = membersImport;
var networkImport = require("../resources/network/types.js");
var network = exports.network = networkImport;
var notificationImport = require("../resources/notification/types.js");
var notification = exports.notification = notificationImport;
var notificationsImport = require("../resources/notifications/types.js");
var notifications = exports.notifications = notificationsImport;
var roomsImport = require("../resources/rooms/types.js");
var rooms = exports.rooms = roomsImport;
var sessionImport = require("../resources/session/types.js");
var session = exports.session = sessionImport;
var sipImport = require("../resources/sip/types.js");
var sip = exports.sip = sipImport;
var usersImport = require("../resources/users/types.js");
var users = exports.users = usersImport;
var voiceMailsImport = require("../resources/voiceMails/types.js");
var voiceMails = exports.voiceMails = voiceMailsImport;
var webRTCImport = require("../resources/webRTC/types.js");
var webRTC = exports.webRTC = webRTCImport;
var websocketImport = require("../resources/websocket/types.js");
var websocket = exports.websocket = websocketImport;
var _default = exports.default = {
  activities,
  app,
  contacts,
  entities,
  feedItems,
  feeds,
  members,
  network,
  notification,
  notifications,
  rooms,
  session,
  sip,
  users,
  voiceMails,
  webRTC,
  websocket
};